import { USER_PERMISSIONS } from "@/roles/types/enums";
import { getAccessStatus } from "@/stores/useUserDataStore";

import { COMPANIES_ACTIONS, ROUTES } from "../../../../../shared";
import CreateCompanyDialog from "../../dialogs/companies/CreateCompanyDialog/CreateCompanyDialog";
import MoveCompanyDialog from "../../dialogs/companies/MoveCompanyDialog/MoveCompanyDialog";
import { useDialog } from "../../hooks/useDialog";
import PageHeaderActions from "../PageHeaderActions";

const CompaniesHeaderActions = () => {
  const { isDialogOpen, openDialog, closeDialog } = useDialog();

  const canMoveItem = getAccessStatus(USER_PERMISSIONS.ManageCompanies);

  return (
    <PageHeaderActions
      route={ROUTES.Companies}
      openDialog={openDialog}
      addItem
      moveItem={canMoveItem}
    >
      <CreateCompanyDialog
        isOpen={isDialogOpen[COMPANIES_ACTIONS.CreateCompany]}
        onClose={closeDialog}
      />
      <MoveCompanyDialog
        isOpen={isDialogOpen[COMPANIES_ACTIONS.MoveCompany]}
        onClose={closeDialog}
      />
    </PageHeaderActions>
  );
};

export default CompaniesHeaderActions;
